import moment from 'moment'
import Vue from 'vue'
import priceFromCent from './price-from-cent'
moment.locale('de-at')

Vue.filter('date', date => date ? moment(date).format('DD.MM.YYYY') : '')
Vue.filter('datetime', date => date ? moment(date).format('DD.MM.YYYY HH:mm') : '')
Vue.filter('priceFromCent', cents => cents ? priceFromCent(cents) : '')
Vue.filter('priceFromCentZero', cents => {
  if (cents === 0) {
    return 0
  }
  return cents ? priceFromCent(cents) : ''
})
Vue.filter('priceFromCentOrEmpty', cents => cents ? priceFromCent(cents) : 'Nicht eingetragen')
Vue.filter('priceFromCentEuro', cents => cents ? ((cents / 100).toFixed(2).replace('.', ',') + '€') : '')
Vue.filter('priceFromCentZeroEuro', cents => {
  if (cents === 0) {
    return '0€'
  }
  return cents ? ((cents / 100).toFixed(2).replace('.', ',') + '€') : ''
})
Vue.filter('formatTax', tax => tax ? (tax * 100) + '%' : '')
